const roofTypeDiv = document.querySelector('.roofType');
const imgElement = document.querySelector('.elementor-element-f687dad')?.querySelector('img');
const defaultImageUrl = window.location.origin + '/wp-content/uploads/2023/12/wycena-wymiary-1.png';
const newImageUrl =
    window.location.origin + '/wp-content/uploads/2023/12/wycena-wymiary-wolnostojace.png';

if (roofTypeDiv && imgElement) {
    jQuery('select', roofTypeDiv).on('change', function (event) {
        if (event.target.value === 'Wolnostojące') {
            imgElement.src = newImageUrl;
            imgElement.setAttribute('srcset', newImageUrl);
        } else {
            imgElement.src = defaultImageUrl;
            imgElement.setAttribute('srcset', defaultImageUrl);
        }
    });
}
